var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { domainService } from '~/config/server';
import { NetService } from '~/utils/net.service';
import { Inject } from '~/core/decorator';
import { FilterService } from '~/utils/filter.service';
var CaseAssitVisitStayService = /** @class */ (function () {
    function CaseAssitVisitStayService() {
    }
    /**
     * 协催管理-诉讼待分配-待分配列表
     */
    CaseAssitVisitStayService.prototype.searchPendingList = function (data, page, sort) {
        return this.netService.send({
            server: domainService.caseAssistVisitStayCotroller.searchPendingList,
            data: {
                caseNumber: data.caseNumber,
                personalName: data.personalName,
                mobileNo: data.mobileNo,
                idCard: data.idCard,
                areaId: data.areaId,
                addressDetail: data.addressDetail,
                overdueAmountMax: data.overdueAmount ? data.overdueAmount.max : '',
                overdueAmountMin: data.overdueAmount ? data.overdueAmount.min : '',
                overdueDaysMax: data.overdueDays ? data.overdueDays.max : '',
                overdueDaysMin: data.overdueDays ? data.overdueDays.min : '',
                turnSource: data.turnSource,
                productCategory: data.productCategory,
                createTimeStart: FilterService.dateRanageFormat(data.creatTime).start,
                createTimeEnd: FilterService.dateRanageFormat(data.creatTime).end,
                productName: data.productName,
                lawNumber: data.lawNumber,
                customerCategory: data.customerCategory,
                overduePeriod: data.overduePeriod,
                labelName: data.labelName
            },
            page: page,
            sort: sort,
        });
    };
    /**
     * 协催管理-诉讼待分配--待分配手动分案预览
     */
    CaseAssitVisitStayService.prototype.synergisticDistribution = function (data) {
        return this.netService.send({
            server: domainService.caseAssistVisitStayCotroller.synergisticDistribution,
            data: data,
        });
    };
    /**
     * 协催管理-诉讼待分配-手动分案确认
     */
    CaseAssitVisitStayService.prototype.confirmDistributeCase = function (data) {
        return this.netService.send({
            server: domainService.caseAssistVisitStayCotroller.confirmDistributeCase,
            data: data,
        });
    };
    /**
     * 协催管理-诉讼待分配-委外分配案件
     */
    CaseAssitVisitStayService.prototype.confirmDistributeCaseOut = function (data) {
        return this.netService.send({
            server: domainService.caseAssistVisitStayCotroller.confirmDistributeCaseOut,
            data: data,
        });
    };
    /**
     * 协催管理-诉讼待分配-委外机构分案
     */
    CaseAssitVisitStayService.prototype.outsourcingCases = function (data) {
        return this.netService.send({
            server: domainService.caseAssistVisitStayCotroller.outsourcingCases,
            data: data,
        });
    };
    __decorate([
        Inject(NetService)
    ], CaseAssitVisitStayService.prototype, "netService", void 0);
    return CaseAssitVisitStayService;
}());
export { CaseAssitVisitStayService };
